module.exports = __webpack_public_path__ + "static/rpa_header-1ae7179fa04c157c8ecb097c6f7382d9.png";